import { type KeywordFlaggingDataSource } from '../../data/keyword-flagging.datasource'
import { type KeywordListSummary } from '../models/keyword-list.model'

export class GetKeywordListsInteractor {
  constructor(private readonly dataSource: KeywordFlaggingDataSource) {}

  async execute(search?: string): Promise<KeywordListSummary[]> {
    const entities = await this.dataSource.getAll()
    let results = entities.map((e) => ({
      id: e.id,
      name: e.name,
      itemCount: e.keywords.length,
      autoModeration: e.auto_moderation,
      dateModified: new Date(e.date_modified)
    }))

    if (search?.trim()) {
      const term = search.trim().toLowerCase()
      results = results.filter((r) => r.name.toLowerCase().includes(term))
    }

    return results
  }
}
